import type { HowToProps } from '@/components/landing-page/components/how-to';

export const defaults: Required<HowToProps> = {
  title: 'Wie geht’s jetzt weiter?',
  list: [
    'Sie erteilen uns eine Vollmacht, damit wir in Ihrem Namen bei der Behörde Einspruch einlegen. Dies geht ganz einfach Online und dauert nur 2 Minuten. <strong>Klicken Sie auf den unteren button</strong> um zur Vollmacht zu gelangen.',
    'Wir fordern Ihre Akte an und unsere Rechtsanwälte beginnen mit der Arbeit an ihrem Fall. Sollten wir Rückfragen haben oder Ihre Zuarbeit benötigen, melden wir uns umgehend bei Ihnen.',
  ],
  className: '',
};
